// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import AMap from 'vue-amap'
import '@/style/frozen.css'
Vue.config.productionTip = false

// 手机调试插件
// import VConsole from 'vconsole'
/* eslint-disable no-unused-vars */
// var vConsole = new VConsole()
// Vue.use(AMap)
// // 初始化vue-amap
// AMap.initAMapApiLoader({
//   // 高德的key
//   key: '78e2bfb982b0712db9793642e51454ce',
//   // 插件集合
//   plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor']
// })
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js